import { initializeApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCAHbWJQpNYW5MU9MXL50ZDVFutxlhJsXI",
  authDomain: "portfolio-62c47.firebaseapp.com",
  projectId: "portfolio-62c47",
  storageBucket: "portfolio-62c47.firebasestorage.app",
  messagingSenderId: "780548504238",
  appId: "1:780548504238:web:9722df7112bc5bd93d4b3f",
  measurementId: "G-LWSW9PMGSN"
};


const firebaseApp = initializeApp(firebaseConfig);
export const firestore = getFirestore(firebaseApp);

export const portfolioDataRef = collection(firestore, 'portfolioData');
export const paintingsRef = collection(firestore, 'paintings');
export const roboticsRef = collection(firestore, 'robotics');

export default firebaseApp;